<ng-container>
    <div class="mx-5 my-4 quote-parameters-container">
        <div class="px-2">
            <div class="quote-container">
                <h4 class="mb-3"></h4>
                <button class="btn btn-sm btn-primary my-1" (click)="toggleReadonly()"> Edit </button>
              </div>
            <form [formGroup]="systemConfigForm" class="mt-5">
                <div class="row mb-5 mt-6">
                    <div class="col-12 col-md-6 mb-5 form-container">
                        <label class="form-label form-label-floating mb-3 required"
                            [ngClass]="{'border-danger': systemConfigForm.get('name')?.invalid && systemConfigForm.get('name')?.touched && !isReadonly()}">Name</label>
                        <input type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadonly()"
                            [ngClass]="{'border-danger': systemConfigForm.get('name')?.invalid && systemConfigForm.get('name')?.touched && !isReadonly()}"
                            formControlName="name" placeholder="" name="name" />
                        @if (systemConfigForm.get('name')?.invalid && systemConfigForm.get('name')?.touched && !isReadonly())
                        {
                        <span class="text-danger">
                            @if (systemConfigForm.get('name')?.errors?.['required']) {
                            Name is required.
                            }
                        </span>
                        }
                    </div>

                    <div class="col-12 col-md-6 mb-5 form-container">
                        <label class="form-label form-label-floating mb-3 required" 
                        [ngClass]="{'border-danger': systemConfigForm.get('environment')?.invalid && systemConfigForm.get('environment')?.touched && !isReadonly()}">Environment</label>
                        <input type="text"  class="form-control form-control-lg form-control-solid" [readOnly]="isReadonly()"
                        [ngClass]="{'border-danger': systemConfigForm.get('environment')?.invalid && systemConfigForm.get('environment')?.touched && !isReadonly()}"
                            formControlName="environment" placeholder="" name="environment" />
                            @if (systemConfigForm.get('environment')?.invalid && systemConfigForm.get('environment')?.touched && !isReadonly())
                            {
                            <span class="text-danger">
                                @if (systemConfigForm.get('environment')?.errors?.['required']) {
                                Environment is required.
                                }
                            </span>
                            }
                    </div>
                </div>

                <!-- <div class="row mb-5 mt-6">
                    <div class="col-12 col-md-6 mb-5 form-container">
                        <label class="form-label form-label-floating mb-3 required"
                         [ngClass]="{'border-danger': systemConfigForm.get('logo')?.invalid && systemConfigForm.get('logo')?.touched}" >Logo</label>
                        <input type="text" class="form-control form-control-lg form-control-solid"
                        [ngClass]="{'border-danger': systemConfigForm.get('logo')?.invalid && systemConfigForm.get('logo')?.touched}"
                            formControlName="logo" placeholder="" name="logo" />
                            @if (systemConfigForm.get('logo')?.invalid && systemConfigForm.get('logo')?.touched)
                            {
                            <span class="text-danger">
                                @if (systemConfigForm.get('logo')?.errors?.['required']) {
                                Logo is required.
                                }
                            </span>
                            }
                    </div>
                </div> -->

                <div class="row mb-5 mt-6">
                    <div class="col-12 col-md-6 mb-5 form-container">
                        <label class="form-label form-label-floating mb-3 required" 
                        [ngClass]="{'border-danger': systemConfigForm.get('complianceRequirement')?.invalid && systemConfigForm.get('complianceRequirement')?.touched && !isReadonly()}">Compliance Requirement</label>
                        <input type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadonly()"
                        [ngClass]="{'border-danger': systemConfigForm.get('complianceRequirement')?.invalid && systemConfigForm.get('complianceRequirement')?.touched && !isReadonly()}"
                            formControlName="complianceRequirement" placeholder="" name="complianceRequirement" />

                            @if (systemConfigForm.get('complianceRequirement')?.invalid && systemConfigForm.get('complianceRequirement')?.touched && !isReadonly())
                            {
                            <span class="text-danger">
                                @if (systemConfigForm.get('complianceRequirement')?.errors?.['required']) {
                                Compliance requirement is required.
                                }
                            </span>
                            }
                    </div>
                    <div class="col-12 col-md-6 mb-5 form-container">
                        <label class="form-label form-label-floating mb-3 required" 
                        [ngClass]="{'border-danger': systemConfigForm.get('prPrimaryURL')?.invalid && systemConfigForm.get('prPrimaryURL')?.touched && !isReadonly()}">PR Primary URL</label>
                        <input type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadonly()"
                        [ngClass]="{'border-danger': systemConfigForm.get('prPrimaryURL')?.invalid && systemConfigForm.get('prPrimaryURL')?.touched && !isReadonly()}"
                            formControlName="prPrimaryURL" placeholder="" name="prPrimaryURL" />
                            @if (systemConfigForm.get('prPrimaryURL')?.invalid && systemConfigForm.get('prPrimaryURL')?.touched && !isReadonly())
                            {
                            <span class="text-danger">
                                @if (systemConfigForm.get('prPrimaryURL')?.errors?.['required']) {
                                PR primary url is required.
                                }
                            </span>
                            }
                    </div>
                </div>
                <div class="row mb-5 mt-6">
                    <div class="col-12 col-md-6 mb-5 form-container">
                        <label class="form-label form-label-floating mb-3 required" 
                        [ngClass]="{'border-danger': systemConfigForm.get('prSecondaryURL')?.invalid && systemConfigForm.get('prSecondaryURL')?.touched && !isReadonly()}">PR Secondary URL</label>
                        <input type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadonly()"
                        [ngClass]="{'border-danger': systemConfigForm.get('prSecondaryURL')?.invalid && systemConfigForm.get('prSecondaryURL')?.touched && !isReadonly()}"
                            formControlName="prSecondaryURL" placeholder="" name="prSecondaryURL" />
                            @if (systemConfigForm.get('prSecondaryURL')?.invalid && systemConfigForm.get('prSecondaryURL')?.touched && !isReadonly())
                            {
                            <span class="text-danger">
                                @if (systemConfigForm.get('prSecondaryURL')?.errors?.['required']) {
                                PR secondary is required.
                                }
                            </span>
                            }
                    </div>
                    <div class="col-12 col-md-6 mb-5 form-container">
                        <label class="form-label form-label-floating mb-3 required"
                         [ngClass]="{'border-danger': systemConfigForm.get('acordPrimaryURL')?.invalid && systemConfigForm.get('acordPrimaryURL')?.touched && !isReadonly()}">Acord Primary URL</label>
                        <input type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadonly()"
                        [ngClass]="{'border-danger': systemConfigForm.get('acordPrimaryURL')?.invalid && systemConfigForm.get('acordPrimaryURL')?.touched && !isReadonly()}"
                            formControlName="acordPrimaryURL" placeholder="" name="acordPrimaryURL" />
                            @if (systemConfigForm.get('acordPrimaryURL')?.invalid && systemConfigForm.get('acordPrimaryURL')?.touched && !isReadonly())
                            {
                            <span class="text-danger">
                                @if (systemConfigForm.get('acordPrimaryURL')?.errors?.['required']) {
                                Acord primary url is required.
                                }
                            </span>
                            }
                    </div>
                </div>
                <div class="row mb-5 mt-6">
                    <div class="col-12 col-md-6 mb-5 form-container">
                        <label class="form-label form-label-floating mb-3 required"
                         [ngClass]="{'border-danger': systemConfigForm.get('acordSecondaryURL')?.invalid && systemConfigForm.get('acordSecondaryURL')?.touched && !isReadonly()}">Acord Secondary URL</label>
                        <input type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadonly()"
                        [ngClass]="{'border-danger': systemConfigForm.get('acordSecondaryURL')?.invalid && systemConfigForm.get('acordSecondaryURL')?.touched && !isReadonly()}"
                            formControlName="acordSecondaryURL" placeholder="" name="acordSecondaryURL" />
                            @if (systemConfigForm.get('acordSecondaryURL')?.invalid && systemConfigForm.get('acordSecondaryURL')?.touched && !isReadonly())
                            {
                            <span class="text-danger">
                                @if (systemConfigForm.get('acordSecondaryURL')?.errors?.['required']) {
                                Acord secondary url is required.
                                }
                            </span>
                            }
                    </div>
                    <div class="col-12 col-md-6 mb-5 form-container">
                        <label class="form-label form-label-floating mb-3 required"
                         [ngClass]="{'border-danger': systemConfigForm.get('customURL')?.invalid && systemConfigForm.get('customURL')?.touched && !isReadonly()}">Custom URL</label>
                        <input type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadonly()"
                        [ngClass]="{'border-danger': systemConfigForm.get('customURL')?.invalid && systemConfigForm.get('customURL')?.touched && !isReadonly()}"
                            formControlName="customURL" placeholder="" name="customURL" />
                            @if (systemConfigForm.get('customURL')?.invalid && systemConfigForm.get('customURL')?.touched && !isReadonly())
                            {
                            <span class="text-danger">
                                @if (systemConfigForm.get('customURL')?.errors?.['required']) {
                                Custom url is required.
                                }
                            </span>
                            }
                    </div>
                </div>
                <div class="row mb-5 mt-6">
                    <div class="col-12 col-md-6 mb-5 form-container">
                        <label class="form-label form-label-floating mb-3 required" 
                        [ngClass]="{'border-danger': systemConfigForm.get('resetPasswordCount')?.invalid && systemConfigForm.get('resetPasswordCount')?.touched && !isReadonly()}">Reset Password Count</label>
                        <input type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadonly()"
                        [ngClass]="{'border-danger': systemConfigForm.get('resetPasswordCount')?.invalid && systemConfigForm.get('resetPasswordCount')?.touched && !isReadonly()}"
                            formControlName="resetPasswordCount" placeholder="" name="resetPasswordCount" />
                            @if (systemConfigForm.get('resetPasswordCount')?.invalid && systemConfigForm.get('resetPasswordCount')?.touched && !isReadonly())
                            {
                            <span class="text-danger">
                                @if (systemConfigForm.get('resetPasswordCount')?.errors?.['required']) {
                                    Reset password count is required.
                                }
                                @else if (systemConfigForm.get('resetPasswordCount')?.errors?.['pattern']){
                                    Reset password count must be integer 
                                }
                            </span>
                            }
                    </div>
                    <div class="col-12 col-md-6 mb-5 form-container">
                        <label class="form-label form-label-floating mb-3 required" 
                        [ngClass]="{'border-danger': systemConfigForm.get('resetLinkCount')?.invalid && systemConfigForm.get('resetLinkCount')?.touched && !isReadonly()}">Reset Link Count</label>
                        <input type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadonly()"
                        [ngClass]="{'border-danger': systemConfigForm.get('resetLinkCount')?.invalid && systemConfigForm.get('resetLinkCount')?.touched && !isReadonly()}"
                            formControlName="resetLinkCount" placeholder="" name="resetLinkCount" />
                            @if (systemConfigForm.get('resetLinkCount')?.invalid && systemConfigForm.get('resetLinkCount')?.touched && !isReadonly())
                            {
                            <span class="text-danger">
                                @if (systemConfigForm.get('resetLinkCount')?.errors?.['required']) {
                                    Reset Link is required.
                                }
                                @else if (systemConfigForm.get('resetLinkCount')?.errors?.['pattern']){
                                    Reset Link must be integer 
                                }
                            </span>
                            }
                    </div>
                </div>
            </form>
        </div>
    </div>
    <mat-action-row class="accordion-footer d-flex justify-content-end py-5 px-6">
        <button mat-button type="button" class="btn btn-lg btn-light-primary me-3 back-btn" (click)="cancelClick()">Cancel</button>
        <button mat-button type="button" class="btn btn-lg btn-primary continue-btn" (click)="onSystemConfigSubmit()" [disabled]="isReadonly()">Save</button>
    </mat-action-row>
</ng-container>